import { Account } from './account';
import { Address } from './address';
import { Disease } from './disease';
import { EnvironmentGroup } from './environment-group';
import { Image } from './image';
import { ObjectImage } from './object-image';
import { Type } from './type';

export interface Environment {
  address?: Address;
  addressId?: number;
  ageFilter?: boolean;
  allFundInsuranceTypes?: boolean;
  allFundSupportTypes?: boolean;
  applicationRequirements?: boolean;
  class?: string;
  createDate?: Date;
  creatorAccount?: Account;
  creatorAccountId?: number;
  dayOfWeek?: number;
  disclaimer?: string;
  diseaseKeywordFilter?: boolean;
  diseases?: Disease[];
  downloadIndividualFunds?: boolean;
  email?: string;
  environmentGroup?: EnvironmentGroup;
  environmentGroupId?: number;
  id?: number;
  footerHeight?: number;
  grantAmountLabel?: string;
  guid?: string;
  householdIncomeFilter?: boolean;
  householdPersonsFilter?: boolean;
  image?: Image;
  imageAcronym?: string;
  imageTime?: number;
  imageType?: string;
  insuranceFilter?: boolean;
  insuranceTypes?: Type[];
  lastPageContent?: string;
  legalName?: string;
  maxIncome?: boolean;
  name?: string;
  pdfDiseaseHeadingBefore?: string;
  pdfFileName?: string;
  pdfLogo?: string;
  pdfLogoObjectImage?: ObjectImage;
  pdfShowFundGrantAmount?: boolean;
  pdfShowFundHouseholdIncome?: boolean;
  pdfShowFundPersonsInHousehold?: boolean;
  pdfTitle?: string;
  pediatricFunds?: boolean;
  phone?: string;
  showApplicationUrl?: boolean;
  showFundGrantAmount?: any[];
  showFundGrantDescription?: any[];
  showFundGrantFrequency?: any[];
  state?: string;
  stateFilter?: boolean;
  stateLabel?: string;
  supportFilter?: boolean;
  supportTypes?: Type[];
  terms?: string;
  termsPlacement?: any[];
  zipcodeFilter?: boolean;
}
